
import Vue from 'vue'
import axios from 'axios'
import router from '@/router/index'
import store from '@/store/store.js'
import cookie from './cookie.js'
import confirm from './confirm.js'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
Vue.use(iView);

let errorCode = [
	{
		// '102029':'用户无此权限',
		'101008':'病例号不能为空',
		'101009':'FTP服务器异常',
		'101010':'此用户不存在',
		'101015':'此用户类型不存在',
		'101013':'已登录',
		'102025':'此用户已存在',
		// '102026':'此病例无临床信息',
	},{
		// '102029':'The user does not have this permission',
		'101008':'CaseId cannot be null',
		'101009':'FTP server exception',
		'101010':'The user does not exist',
		'101015':'The user type does not exist',
		'101013':'Already Logged in ',
		'102025':'The user already exists',
		// '102026':'This case has no clinical information',
	}
];
let lang = cookie.get('language') || navigator.language.toLocaleLowerCase().substring(0,2)
let errorMsg = (lang=='zh')?errorCode[0]:errorCode[1];
// import store from '../store';
// axios request 拦截器
// Add a request interceptor
axios.interceptors.request.use(function (config) {
	// if ( cookie.get('session')) {
	if (cookie.get('session')) { /*localStorage.getItem('session')|| */
		// config.headers.Authorization = cookie.get('session');
		config.headers.Authorization = cookie.get('session'); /*localStorage.getItem('session')|| */
		// console.log(config.headers.Authorization);
	}
    config.headers.Version = ('V1.1.3');
	// Do something before request is sent
	return config;
}, function (error) {
	// Do something with request error
	return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
	// Do something with response data
	if(response.data.code==101014||response.data.code==102028){
		if(cookie.get('session')||localStorage.getItem('session')){
	        cookie.remove('session');
	        localStorage.removeItem('session');
	    }
	    router.replace({
			path: '/login',
			query: { redirect: router.currentRoute.fullPath }
		});
        confirm({
            title:'温馨提示',
            content:'登录过期，请重新登录',
        },'overdue-modal')
	    /*iView.Modal.info({
	      title:'温馨提示',
	      content:'登录过期，请重新登录'
	    })*/
        // return response.data
	}else{
		if(errorMsg[response.data.code]){
		   return iView.Message.error(errorMsg[response.data.code])//alert(errorMsg[response.data.code])
		}
	}
	return response.data;
},function (error) {
	// Do something with response error
	if (error.response) {
		switch (error.response.status) {
			case 401:
				// 返回 401 清除token信息并跳转到登录页面
				// Toast('登录过期，请重新登录');
				router.replace({
					path: '/login',
					query: { redirect: router.currentRoute.fullPath }
				});
		}
	}
	return Promise.reject(error);
});

// Vue.http.interceptors.push((request,next)=>{
// 	request.headers.set('sid',cookie.get('session') ? cookie.get('session') : sessionStorage.getItem('session'));
// 	next((response) => {
// 		return response
// 	})
// })




// WEBPACK FOOTER //
// ./src/assets/js/axios.js